// extracted by mini-css-extract-plugin
export default {"reason":"Reason_reason__cdbz8","popup":"Reason_popup__kFqT6","toleft":"Reason_toleft__STVqb"};